<template>   
    <LayoutSinMenu>        
        <template #contenido>
            <div class="row">
                <div class="col-12 col-xxl-8 col-xl-8 col-lg-8 col-md-6 col-sm-12 agregar">
                    <p class="titulos-form text-center" type="button" @click="validar"><a-icon type="save" /> REPORTE DE NOVEDADES</p>
                </div>
                <div class="col-12 col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-sm-12">
                    <img src="images/LOGO.png" width="100%" alt="">
                </div>    
            </div>
            <span v-if="loader">
                <Loading :nuevoTitulo="titulo" />
            </span>
            <span v-else>
                
                <div class="row mt-5">
                    <div class="col-12 col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12">
                        <label for="tipo_intervencion">Tipo de intervención</label>
                        <b-form-select 
                            :options="tipos_intervencion" 
                            v-model="novedad.tipo_intervencion" 
                            id="tipo_intervencion"
                        ></b-form-select>
                        <span class="text-danger" v-if="errores">{{ errores.tipo_intervencion }}</span>
                    </div>
                    <div class="col-12 col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12">
                        <label for="fecha_ejecucion">fecha de ejecución</label>
                        <input type="date" id="fecha_ejecucion" class="form-control" v-model="novedad.fecha_ejecucion">
                        <span class="text-danger" v-if="errores">{{ errores.fecha_ejecucion }}</span>
                    </div>
                    <div class="mt-3 col-12 col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12">
                        <label for="proveedor">Proveedor</label>
                        <b-form-select 
                            :options="tipo_proveedor" 
                            v-model="novedad.proveedor" 
                            id="proveedor"
                        ></b-form-select>
                        <span class="text-danger" v-if="errores">{{ errores.proveedor }}</span>
                    </div>
                    <div class="mt-3 col-12 col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12">
                        <label for="lider_intervencion">Lider intervención</label>
                        <b-form-input v-model="novedad.lider_intervencion" id="lider_intervencion"></b-form-input>
                        <span class="text-danger" v-if="errores">{{ errores.lider_intervencion }}</span>
                    </div>   
                    <div class="col-12">
                        <label for="observaciones">Observaciones</label>
                        <textarea name="" id="observaciones" rows="10" v-model="novedad.observaciones" class="form-control"></textarea>
                    </div>
                    <div class="col-12 mt-3">
                        <label for="evidencia">Evidencia (Imagen) *</label>
                        <input 
                            type="file" 
                            id="evidencia" 
                            class="form-control" 
                            @change="handleImageUpload"
                            accept="image/*"
                            ref="evidenciaFile"
                        >
                        <span class="text-danger" v-if="errores && errores.evidencia">{{ errores.evidencia }}</span>
                        <div v-if="imagenPreview" class="mt-2">
                            <img :src="imagenPreview" alt="Vista previa" style="max-width: 200px; max-height: 200px; object-fit: cover; border: 1px solid #ddd; border-radius: 4px;">
                        </div>
                    </div>   
                    <div class="col-12 my-3 agregar-mobile">
                        <p class="titulos-form text-center" type="button" @click="validar"><a-icon type="save" /> AGREGAR UNIDAD</p>
                    </div> 
                </div>
            </span>
        </template>
    </LayoutSinMenu>
</template>
<script>
    import axios from 'axios';
    import LayoutSinMenu from '@/layouts/SinMenu.vue';
    import Loading from '../Loader/Loading.vue';
    
    export default {
        components: {
            LayoutSinMenu, Loading
        },
        props: ['item'],
        data() {
            return {
                edit: false,
                errores: null,
                loader: false,
                imagenArchivo: null,
                imagenPreview: null,
                novedad: {id: null, cbi:null, tipo_intervencion: null, proveedor: null, lider_intervencion: null, observaciones: null, fecha_ejecucion: null},        
                tipos_intervencion: [
                    {text: 'Mantenimiento Preventivo', value: 'Mantenimiento Preventivo'},
                    {text: 'Mantenimiento Correctivo', value: 'Mantenimiento Correctivo'},
                ],   
                tipo_proveedor: [
                    {text: 'Interno', value: 'Interno'},
                    {text: 'Externo', value: 'Externo'},
                ],   
                titulo: 'Cargando información',
            }
        },
        mounted() {
            
        },
        methods: {
            handleImageUpload(event) {
                const file = event.target.files[0];
                if (file) {
                    // Validar que sea una imagen
                    if (!file.type.startsWith('image/')) {
                        Swal.fire({
                            title: 'Atención',
                            icon: 'warning',
                            text: 'Por favor selecciona un archivo de imagen válido'
                        });
                        return;
                    }
                    
                    // Validar tamaño (máximo 5MB)
                    if (file.size > 5 * 1024 * 1024) {
                        Swal.fire({
                            title: 'Atención',
                            icon: 'warning',
                            text: 'La imagen no puede ser mayor a 5MB'
                        });
                        return;
                    }
                    
                    this.imagenArchivo = file;
                    
                    // Crear vista previa
                    const reader = new FileReader();
                    reader.onload = (e) => {
                        this.imagenPreview = e.target.result;
                    };
                    reader.readAsDataURL(file);
                }
            },
            guardar(){
                this.novedad.cbi = this.$route.params.cbi; 
                this.novedad.estado_id = 5; 
                this.loader = true;
                
                // Crear FormData para enviar archivo
                const formData = new FormData();
                
                // Agregar todos los campos de novedad
                Object.keys(this.novedad).forEach(key => {
                    if (this.novedad[key] !== null && this.novedad[key] !== undefined) {
                        formData.append(key, this.novedad[key]);
                    }
                });
                
                // Agregar la imagen
                if (this.imagenArchivo) {
                    formData.append('evidencia', this.imagenArchivo);
                }
                
                axios.post('/api/novedades', formData, {
                    headers: {
						"Authorization": `Bearer ${this.$store.state.user.token}`,
                        "Content-Type": "multipart/form-data"
					}
                })
                .then(res => {
                    console.log(res.data)
                    if(res.data.status === 'errorValidation'){
                        this.errores = res.data.error;
                        this.loader = false;
                    }else{
                        this.loader = false;
                        Swal.fire({
                            icon: 'success',
                            title: 'Novedad agregada con exito',
                            allowOutsideClick: false,
                            allowEscapeKey: false,
                            confirmButtonText: 'Aceptar'
                        }).then((result) => {
                            if(result.value){
                                this.$router.go(-1)
                            }
                        })
                    }
                })
                .catch(err => {
                    this.loader = false;
                    console.log(err)
                })
            },
           
            validar(){
                this.titulo = 'Estamos guardando la información';
                if(this.novedad.tipo_intervencion === null || this.novedad.tipo_intervencion === '' || this.novedad.tipo_intervencion === undefined){
                    Swal.fire({
                        title: 'Atención',
                        icon: 'warning',
                        text: 'El campo tipo de intervención no es valido'
                    })
                    return
                }
                if(this.novedad.fecha_ejecucion === null || this.novedad.fecha_ejecucion === '' || this.novedad.fecha_ejecucion === undefined){
                    Swal.fire({
                        title: 'Atención',
                        icon: 'warning',
                        text: 'El campo fecha de ejecución no es valido'
                    })
                    return
                }
                if(this.novedad.proveedor === null || this.novedad.proveedor === '' || this.novedad.proveedor === undefined){
                    Swal.fire({
                        title: 'Atención',
                        icon: 'warning',
                        text: 'El campo proveedor no es valido'
                    })
                    return
                }

                if(this.novedad.lider_intervencion === null || this.novedad.lider_intervencion === '' || this.novedad.lider_intervencion === undefined){
                    Swal.fire({
                        title: 'Atención',
                        icon: 'warning',
                        text: 'El campo lider de intervención no es valido'
                    })
                    return
                }

                

                if(this.novedad.observaciones === null || this.novedad.observaciones === '' || this.novedad.observaciones === undefined){
                    Swal.fire({
                        title: 'Atención',
                        icon: 'warning',
                        text: 'El campo observaciones no es valido'
                    })
                    return
                }
                
                if(!this.imagenArchivo){
                    Swal.fire({
                        title: 'Atención',
                        icon: 'warning',
                        text: 'Debe cargar una imagen como evidencia'
                    })
                    return
                }
                
                this.guardar();
            }
        },
    }
</script>
<style scoped>
    .anticon{
        vertical-align: 0 !important;
    }

    .agregar-mobile{
        display: none;
    }

    @media screen and (max-width:768px){
        .agregar-mobile{
            display: block;
        }
        .agregar{
            display: none;
        }
    }
</style>